/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a[_ngcontent-%COMP%] {\r\n    color:#073E61;\r\n}\r\n\r\n.dropdown-menu[_ngcontent-%COMP%] {\r\n    width:250px;\r\n}"];
export { styles as styles };
